import { useNavigate } from 'react-router';
import { useAuthToken } from '@repo/hooks/useAuthToken';
import { Button } from '@repo/ui/Button';

export const DeactivatedAccount = () => {
  const navigate = useNavigate();
  const setToken = useAuthToken()[1];

  const handleLogout = () => {
    localStorage.setItem('mercury_skip_redirect', 'true');
    setToken(null);
    navigate('/login');
  };

  return (
    <div className="grid w-screen h-screen place-items-center">
      <div className="flex flex-col items-center max-w-lg text-center">
        <span className="mb-4 text-8xl material-symbols-outlined dark:text-white">block</span>

        <h1 className="mb-4 text-2xl font-bold dark:text-white">Account Deactivated</h1>

        <p className="mb-8 text-xl dark:text-gray-300">
          This account has been deactivated. Please contact support to reactivate your account.
        </p>

        <div className="flex gap-4">
        

          <Button variant="secondary" onClick={handleLogout}>
            Sign Out
          </Button>

          <Button onClick={() => navigate(-1)}>
           Go Back to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};
